import { connect } from '@atlassian/jira-react-redux';
import type { InitialState as State } from '@atlassian/jira-servicedesk-common/src/state/types';
import ReadyForUser from '@atlassian/jira-servicedesk-common/src/ui/components/ready-for-user';

import { getBaseUrl } from '../../state/selectors/app-props';

const mapStateToProps = (state: State) => ({
	baseUrl: getBaseUrl(state),
});

export default connect(mapStateToProps, {})(ReadyForUser);
